module.exports = __webpack_public_path__ + "static/media/5DPO18.12a9614f.jpg";